const initialState = {
  isLoading: false,
  employees: [],
  selectedEmployees: [],
  byId: {}
};

export function employees (state = initialState, action) {
  switch (action.type) {
    case 'SELECT_EMPLOYEES':
      return {
        ...state,
        selectedEmployees: action.value ? [...state.selectedEmployees, action.id] : state.selectedEmployees.filter(e => e !== action.id)
      };
    case 'FETCH_EMPLOYEES':
      return {
        ...state,
        isLoading: false,
        employees: [],
        selectedEmployees: []
      };
    case 'FETCH_EMPLOYEES_LOADING':
      return {
        ...state,
        isLoading: true
      };
    case 'FETCH_EMPLOYEES_SUCCESS':
      const grouped = Object.assign({}, ...action.employees.map(employee => ({
        [employee.id]: employee
      })));

      return {
        ...state,
        isLoading: false,
        employees: action.employees,
        selectedEmployees: action.employees.map((e) => e.id),
        byId: grouped
      };
    default:
      return state;
  }
}
